"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _exclamation = _interopRequireDefault(require("../../assets/png/exclamation.png"));
var _ = require("./..");
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ValidationSpan = function ValidationSpan(_ref) {
  var isValid = _ref.isValid,
    show = _ref.show;
  if (!show) {
    return null;
  }
  return isValid ? /*#__PURE__*/_react.default.createElement(_styled.Span, {
    valid: true
  }, /*#__PURE__*/_react.default.createElement(_.CheckIcon, null)) : /*#__PURE__*/_react.default.createElement(_styled.Span, {
    valid: false
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _exclamation.default,
    alt: "errors"
  }));
};
ValidationSpan.propTypes = {
  isValid: _propTypes.default.bool.isRequired,
  show: _propTypes.default.bool
};
ValidationSpan.defaultProps = {
  show: false
};
var _default = ValidationSpan;
exports.default = _default;